<ng-template #showVerifyModal let-modal>
    <div class="modal-header header-rectangle">
        <div class="cursor-pointer" (click)="onClose()">
            <i class="mdi mdi-arrow-left mdi-24px"></i>
        </div>
        <span class="font-b2" style="padding-right: 24px;">Verificá tu tarjeta</span>
    </div>
    <div class="p-20 text-center">  
        <div class="font-14 font-bold">Para utilizar el Givi POP</div>
        <div class="font-12 m-t-20">
            Nos tomamos muy en serio la seguridad por el bienestar de nuestros usuarios, el Givi POP vas a poder utilizarlo o regalarlo una vez que verifiquemos tu identidad. 
        </div>
        <div class="m-t-20">
            <div class="row">
                <div class="col-6 d-flex-center align-items-center">
                    <div class="font-12 font-bold">Selfie con tu cedula</div>
                </div>
                <div class="col-6 d-flex-center align-items-center">
                    <div class="font-12 font-bold">Tarjeta con los 4 números visibles</div>
                </div>
                <div class="col-6">
                    <img src="assets/images/selfieID.png" class="w-100 m-b-20">
                    
                    <div *ngIf="!showCameraForSelfie" class="font-14 font-bold text-primary text-center" (click)="onShowCameraForSelfie()">
                        <i class="mdi mdi-camera-outline"></i>Tomar Foto
                    </div>
                    <div *ngIf="showCameraForSelfie" class="font-14 font-bold text-primary text-center" (click)="onShowCameraForSelfie()">
                        <i class="mdi mdi-camera-off-outline"></i>
                        Ocultar Cámara
                    </div>
                    
                    <webcam [height]="150" [width]="150" [trigger]="triggerObservableForSelfie" (imageCapture)="uploadSelfiePhoto($event)" *ngIf="showCameraForSelfie"
                            [imageQuality]="1"
                    ></webcam>
                    
                    <div *ngIf="showCameraForSelfie" class="btn-capture" (click)="triggerCaptureForSelfie();">
                        <i class="mdi mdi-camera-iris"></i>Capturar
                    </div>

                    <div class="snapshot" *ngIf="selfieLogoURL">
                        <img [src]="selfieLogoURL" style="transform: scaleX(-1);" [height]="115" [width]="150"/>
                    </div>
                    
                    <!--  <div class="upload-container m-t-20">
                        <div class="font-12 font-bold">Subir Selfie</div>
                        <input type="file" id="file-upload" accept="image/*" class="d-none" (change)="uploadSelfiePhoto($event)" />
                        <label for="file-upload" class="upload-image" *ngIf="!selfieLogoURL">
                            <img src="assets/images/SubirImagenCuadrada.png" class="w-100" alt="Carga tu foto aquí" />
                        </label>
                        <label for="file-upload" class="upload-event-image" *ngIf="selfieLogoURL">
                            <img src="{{selfieLogoURL}}" alt="Carga tu foto aquí" class="w-100" style="height: 140px;"/>
                        </label>
                    </div> -->
                    <small class="text-danger" *ngIf="selfieSizeError">
                        {{selfieSizeError}}
                    </small>

                </div>
                <!-- Card -->
                <div class="col-6">
                    <img src="assets/images/cardnumbers.png" class="w-100 m-b-20">
                    
                    <div *ngIf="!showCameraForCard" class="font-14 font-bold text-primary text-center" (click)="onShowCameraForCard()">
                        <i class="mdi mdi-camera-outline"></i>Tomar Foto
                    </div>
                    <div *ngIf="showCameraForCard" class="font-14 font-bold text-primary text-center" (click)="onShowCameraForCard()">
                        <i class="mdi mdi-camera-off-outline"></i>
                        Ocultar Cámara
                    </div>
                    
                    <webcam [height]="150" [width]="150" [trigger]="triggerObservableForCard" (imageCapture)="uploadCardPhoto($event)" *ngIf="showCameraForCard"
                            [imageQuality]="1"
                    ></webcam>
                    
                    <div *ngIf="showCameraForCard" class="btn-capture" (click)="triggerCaptureForCard();">
                        <i class="mdi mdi-camera-iris"></i>Capturar
                    </div>

                    <div class="snapshot" *ngIf="cardLogoURL">
                        <img [src]="cardLogoURL" style="transform: scaleX(-1);" [height]="115" [width]="150"/>
                    </div>

                    <!-- <div class="upload-container m-t-20">
                        <div class="font-12 font-bold">Subir Tarjeta</div>
                        <input type="file" id="file-upload2" accept="image/*" class="d-none" (change)="uploadCardPhoto($event)" />
                        <label for="file-upload2" class="upload-image" *ngIf="!cardLogoURL">
                            <img src="assets/images/SubirImagenCuadrada.png" class="w-100" alt="Carga tu foto aquí" />
                        </label>
                        <label for="file-upload2" class="upload-event-image" *ngIf="cardLogoURL">
                            <img src="{{cardLogoURL}}" alt="Carga tu foto aquí" class="w-100 img-fluid" style="height: 140px;" />
                        </label>
                    </div> -->
                    <small class="text-danger" *ngIf="cardSizeError">
                        {{cardSizeError}}
                    </small>
                </div>
            </div>
        </div>
        <div class="m-t-20">
            <button class="btn btn-primary" (click)="onSendImages()" [disabled]="!selfieLogoURL || !cardLogoURL">Verificar Identidad</button>
        </div>
    </div>
</ng-template>